import http from '../../../../libs/http'
export default (queryParams = {}) => http.get(`${process.env.VUE_APP_MICROSERVICE_API_SHOPS}/orders`, {
  params: { ...queryParams }
})
